import { render } from "./StockAlert.vue?vue&type=template&id=6ef1edb7"
import script from "./StockAlert.vue?vue&type=script&lang=js"
export * from "./StockAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__